import SiteContactList from "./pages/ListPage.vue";
import SiteContactDetail from "./pages/FormPage.vue";
import SiteContactIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/site_contact",
    component: SiteContactIndex,
    redirect: "/site_contact/list",
    name: "site_contact",
    children: [
      {
        path: "list",
        component: SiteContactList,
        name: "site_contact.list",
      },
      {
        path: "create",
        component: SiteContactDetail,
        name: "site_contact.create",
        props: { create: true },
      },
      {
        path: "edit/:id",
        component: SiteContactDetail,
        name: "site_contact.edit",
        props: { create: false },
      },
    ],
  },
];
